import { HarmReport, ReportStatus, User } from '@inplay/models';
import { ReactNode } from 'react';

export type DeletedHarmReport = HarmReport & {
  deletedOn: Date;
  deletedBy: User;
  status: ReportStatus.DELETED;
};

export interface DeletedHarmReportsFilter {
  searchQuery: string;
  selectedDate: Date;
}

export interface DeletedHarmReportsProps {}

export interface DeletedHarmReportsTableHeaderProps {
  searchQuery: string;
  handleOnChangeSearch: (query: string) => void;
  selectedDate?: Date;
  handleSelectedDate?: (date: Date) => void;
  children?: ReactNode;
}

export interface DeletedHarmReportsTableFilterProps {
  isOpenFilterModal: boolean;
  handleClearFilters: () => void;
  handleApplyFilters: (filters: any) => void;
  toggleFilterModal: (value: boolean) => void;
}

export enum DeletedHarmReportsKebabOption {
  VIEW = 'View',
  RESTORE = 'Restore',
}
